export default {
  serviceStartDate: '2021-01-01',

  feature: {
    showProjectId: true,
    accountText: 'customer',
    projectText: 'subscription',
  },

  topNavigation: {
    showAccountId: true,
  },

  billing: {
    summary: {
      dataPresentHours: 24, // 한국 시간 기준 오전 9시 (UTC 0시) 이후에 하루전 데이터가 존재한다고 가정함
      dataCompleteHours: 48, // 한국 시간 기준 오전 9시 (UTC 0시) 이후에 이틀 전 데이터가 완전하다고 가정함

      costShareItems: ['costByService', 'costByProject', 'costByRegion', 'costByCountry'],
    },
    costTrend: {
      enabled: false,
    },
    alarm: {
      enabled: false,
    },
  },
};
